import React from "react";
var __jsx = React.createElement;
import { Input } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FormSelect, FormTextarea } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { usePatientNotes } from "@/hooks/patient-content";
/**
 * A single required-aware note field: the asterisk applies to the field as a whole,
 * which is satisfied by either picking an existing note or typing one.
 */
export function MessageSelectorField(_ref) {
  var _notes$data$data$cont, _notes$data;
  var field = _ref.field,
    fieldKey = _ref.fieldKey,
    value = _ref.value,
    setField = _ref.setField,
    patientId = _ref.patientId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notes = usePatientNotes(patientId, true);
  var options = ((_notes$data$data$cont = (_notes$data = notes.data) === null || _notes$data === void 0 || (_notes$data = _notes$data.data) === null || _notes$data === void 0 ? void 0 : _notes$data.content) !== null && _notes$data$data$cont !== void 0 ? _notes$data$data$cont : []).filter(function (note) {
    var _note$comment;
    return note.comment_uuid && ((_note$comment = note.comment) === null || _note$comment === void 0 ? void 0 : _note$comment.trim());
  }).map(function (note) {
    return {
      value: note.comment,
      label: "".concat(note.comment, " \xB7 ").concat(note.user)
    };
  });
  var innerStyles = {
    input: {
      border: "none",
      backgroundColor: "transparent",
      borderRadius: 0
    }
  };
  var selectValue = options.some(function (option) {
    return option.value === value;
  }) ? value : null;
  return /*#__PURE__*/React.createElement(Input.Wrapper, {
    label: field.label,
    withAsterisk: field.required
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden rounded-sds-200 border border-sds-base-secondary focus-within:border-sds-brand-default"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    variant: "unstyled",
    styles: innerStyles,
    placeholder: notes.isLoading ? t("loading", {
      defaultValue: "Loading…"
    }) : t("select_a_note_from_navigation", {
      defaultValue: "Select a note from navigation"
    }),
    data: options,
    value: selectValue,
    onChange: function onChange(next) {
      trackEvent(ANALYTICS_EVENTS.NOTE_SELECT, {
        fieldKey: fieldKey
      });
      if (next) setField(fieldKey, next);
    },
    searchable: true,
    withinPortal: true,
    nothingFound: t("no_notes", {
      defaultValue: "No notes"
    }),
    "data-testid": "note-select-".concat(fieldKey)
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-sds-base-secondary"
  }), /*#__PURE__*/React.createElement(FormTextarea, {
    variant: "unstyled",
    styles: innerStyles,
    minRows: 4,
    value: value,
    onChange: function onChange(event) {
      return setField(fieldKey, event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.NOTE_TEXT, {
        fieldKey: fieldKey
      });
    },
    placeholder: t("enter_note_or_select", {
      defaultValue: "Enter note text or select a note from navigation…"
    }),
    "data-testid": "note-text-".concat(fieldKey)
  })));
}